"use strict";

angular.module('PatientApp').controller('FeedbackCtrl', ['$rootScope', '$scope', '$state', '$filter', '$log', '_', 'PatientUsersService', 'Config', 'FeedbackService', '$location', '$anchorScroll', 'VueEventTransmitter', function ($rootScope, $scope, $state, $filter, $log, _, PatientUsersService, Config, FeedbackService, $location, $anchorScroll, VueEventTransmitter) {
  var _reset = function _reset() {
    $scope.feedback = {
      comment: ''
    };

    if ($scope.forms && $scope.forms.feedbackForm) {
      $scope.forms.feedbackForm.$setPristine();
    }

    $scope.submitting = false;
    $scope.showFeedback = false;
    $scope.scoreClean = true;
    $scope.buttonText = $filter('translate')('actions.sendFeedback');
  },
      _destroyStateChangeStart = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    if (toState.name === 'app.default.feedback') {
      $scope.afterPayment = false;
      $scope.feedback.feedbackToken = toParams.token;
      $scope.feedback.useNPS = toParams.nps == 1;

      var _defaultScore = $scope.feedback.useNPS ? 10 : 1; //default to happy if there's nothing passed-in


      var score = toParams.score ? parseInt(toParams.score) : _defaultScore;

      if ($scope.feedback.useNPS) {
        if (score > 10) {
          score = 10;
        } else if (score < 1) {
          score = 0;
        }
      } else {
        if (score != 0 && score != 1) {
          score = 1;
        }
      }

      PatientUsersService.addFeedback($scope.feedback.feedbackToken, score, $scope.feedback.useNPS).then(function (data) {
        $scope.feedbackSource = data.feedbackSource;
        $scope.providerName = data.providerName;
        $scope.translationData = {
          providerName: $scope.providerName
        };
        $scope.feedback.feedbackId = data.feedbackId;
        $scope.setScore(score);
        $scope.feedback.options = data.options;
        $scope.lang = Config.preferredLanguage || 'en'; //don't show until after first ajax finishes.  otherwise, we give the impression that they can submit a comment 
        //(and they can't - because they're missinging the id)

        $scope.showFeedback = true;
      });
    }
  }),
      getSelectedFeedbackOptions = function getSelectedFeedbackOptions() {
    if ($scope.feedback.useNPS && $scope.feedback.npsScore < 7) {
      return $scope.feedback.options.filter(function (option) {
        return option.selected === true;
      }).map(function (option) {
        return option.optionId;
      });
    } else {
      return null;
    }
  };

  _reset();

  $scope.forms = {
    feedbackForm: {}
  }; // after payment NPS

  $rootScope.$on('feedbackModal:showPrompt', function (event, data) {
    FeedbackService.getOptions().then(function (resp) {
      $scope.feedback.options = resp;
    });
    $scope.forms = {
      feedbackForm: {}
    };
    $scope.scoreClean = true;
    $scope.afterPayment = true;
    $scope.feedback.useNPS = true;
    $scope.paymentId = data.receipt.paymentId;
    $scope.feedbackSource = 'postPayment';
    $scope.translationData = {
      providerName: data.providerName
    };

    if (data.receipt.vendor && data.receipt.vendor.toLowerCase() === 'curae') {
      $scope.thanksHeader = $filter('translate')('payment.financing.success.financingSuccessHeader', {
        vendor: data.receipt.vendor
      });
    } else {
      $scope.thanksHeader = $filter('translate')('dialogs.thanksForPayment', $scope.translationData);
    }

    $scope.feedbackTitle = $filter('translate')('dialogs.feedbackTitleNpsLink', $scope.translationData);
    $scope.iconClass = 'icon-check';
    $scope.intentIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="75px" height="75px">' + '<g fill="none" stroke="#fff" stroke-width="2">' + '<circle cx="36" cy="36" r="35" style=""></circle>' + '<path d="M17.417,37.778l9.93,9.909l25.444-25.393" style=""></path>' + '</g>' + '</svg>';
    $scope.lang = Config.preferredLanguage || 'en';
    $scope.showFeedback = true;
  }); // post to capture data if user clicks on score but doesn't click submit

  $scope.addFeedbackAfterPayment = function (score) {
    FeedbackService.updateScore($scope.paymentId, score, $scope.feedback.feedbackId).then(function (data) {
      $scope.feedback.feedbackId = data;
    });
  };

  $scope.setScore = function (newScore) {
    $scope.scoreClean = false;

    if ($scope.feedback.useNPS) {
      $scope.feedback.npsScore = newScore;

      if ($scope.afterPayment === true) {
        $scope.addFeedbackAfterPayment(newScore);
      }

      $scope.feedbackTitle = $filter('translate')('dialogs.feedbackTitleNpsLink', $scope.translationData);

      if ($scope.feedback.npsScore > 6) {
        $scope.commentPrompt = $filter('translate')('dialogs.feedbackSubtitleNpsHappy');
      } else {
        $scope.commentPrompt = $filter('translate')('dialogs.feedbackSubtitleNpsSad');
      }
    } else {
      $scope.feedback.happySelected = newScore === 1;

      if ($scope.feedbackSource === 'receiptLink') {
        $scope.feedbackTitle = $filter('translate')('dialogs.feedbackTitleReceiptLink');
        $scope.commentPrompt = $scope.feedback.happySelected ? $filter('translate')('dialogs.feedbackSubtitlePaymentHappy') : $filter('translate')('dialogs.feedbackSubtitlePaymentSad');
      } else if ($scope.feedbackSource === 'closedMessageLink') {
        $scope.feedbackTitle = $filter('translate')('dialogs.feedbackTitleClosedMessageLink', $scope.translationData);
        $scope.commentPrompt = $scope.feedback.happySelected ? $filter('translate')('dialogs.feedbackSubtitleClosedMessageHappy') : $filter('translate')('dialogs.feedbackSubtitleClosedMessageSad');
      }
    }
  };

  $scope.scrollDown = function () {
    $location.hash('submit-feedback');
    $anchorScroll();
  };

  $scope.getScore = function () {
    if ($scope.feedback.useNPS) {
      return $scope.feedback.npsScore;
    } else {
      return $scope.feedback.happySelected ? 1 : 0;
    }
  };

  $scope.cancel = function () {
    _reset();

    if ($scope.afterPayment) {
      $scope.showFeedback = false;
      $scope.feedback.npsScore = null;
      $scope.commentPrompt = null;

      _reset();
    } else {
      $state.go('app.default');
    }
  };

  $scope.sendFeedback = function () {
    if ($scope.afterPayment) {
      // not validating anything - so no need to check if form is valid
      if ($scope.submitting) {
        return;
      }

      $scope.submitting = true;
      $scope.buttonText = $filter('translate')('actions.sendingFeedback'); //new - after payment feedback - updates all vaules 

      FeedbackService.updateAll($scope.feedback.feedbackId, $scope.paymentId, $scope.getScore(), $scope.feedback.comment, getSelectedFeedbackOptions()).finally(function () {
        $scope.feedback.npsScore = null;
        $scope.commentPrompt = null;

        _reset();
      });
    } else {
      if ($scope.forms.feedbackForm.$invalid || $scope.submitting) {
        return;
      }

      $scope.submitting = true;
      $scope.buttonText = $filter('translate')('actions.sendingFeedback'); //email feedback 
      //no error handling below.  we have no legit situations where this call would fail.  if it does, we'll pretend that it went through and clean-up after ourselves

      PatientUsersService.editFeedback($scope.feedback.feedbackId, $scope.feedback.feedbackToken, $scope.getScore(), $scope.feedback.comment, $scope.feedback.useNPS, getSelectedFeedbackOptions()).finally(function () {
        _reset();

        $state.go('app.default'); // overlay the thank you modal

        VueEventTransmitter.$emit('simpleModal:showPrompt', {
          header: $filter('translate')('dialogs.thanksForFeedback'),
          intent: 'success'
        });
      });
    }
  };

  $scope.$on('$destroy', function () {
    _destroyStateChangeStart();
  });
}]);